import Vue from 'vue'
import { formatCurrency } from './utils'

Vue.filter('formatCurrency', formatCurrency)